import { FC } from "react";
import { useTranslation } from "react-i18next";

import { ArrowRight } from "@/assets/icons/ds";
import { ProductCard } from "@/components/Layout/BaseLayouts/ProductCard/ProductCard";
import { ProductCardFooterItem } from "@/components/Layout/BaseLayouts/ProductCard/ProductCardFooterItem";

export const GoToTariffOverviewTile: FC = () => {
  const { t } = useTranslation(["partnerPortal"], {
    keyPrefix: "cockpit",
  });

  return (
    <ProductCard
      dataTestid="tariff-overview-tile"
      header={
        <div className="flex h-full w-full flex-col items-start gap-3 pt-4">
          <p className="text-body-sm text-foreground-secondary">
            {t("mobileInternet")}
          </p>
          <p className="w-full text-headline-md font-semibold leading-sm text-foreground-primary">
            {t("description")}
          </p>
        </div>
      }
      footer={
        <ProductCardFooterItem
          variant="button"
          label={t("callToAction")}
          icon={<ArrowRight />}
          onClick={() =>
            window.open(t("tariffOverview"), "_blank", "noopener,noreferrer")
          }
        />
      }
    />
  );
};
